if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent) && typeof navigator.msLaunchUri === 'function') {
	navigator.msLaunchUri(
		'microsoft-edge:' + window.location.href,
		function () {
			window.location.href = 'https://go.microsoft.com/fwlink/?linkid=2135547';
		},
		function () {
			console.error('Edge not found.');
		}
	);
}
